




















import type { PropType } from '@vue/composition-api';
import { defineComponent, computed } from '@vue/composition-api';
import { AvatarSize, ParagraphSize } from '@getaccept/lib-ui';
import type { User } from '@getaccept/lib-shared/src/users/types/user';

export default defineComponent({
  name: 'ProfileDropdownButton',
  props: {
    open: {
      type: Boolean,
      required: true,
    },
    user: {
      type: Object as PropType<User>,
      required: true,
    },
    entityName: {
      type: String,
      required: false,
      default: '',
    },
  },
  setup(props) {
    const entityTitle = computed(() => {
      const visibleCharacters = 12;
      return props.entityName?.length > visibleCharacters ? props.entityName : '';
    });

    return {
      AvatarSize,
      ParagraphSize,
      entityTitle,
    };
  },
});
